import React, { useEffect, useState } from "react";
import Loader from "../../../components/common/Loader";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppMutation, useAppQuery } from "../../../api/fetchClient";
import { QUERY_KEYS } from "../../../api/queryKeys";
import { DELETE_CONTENT, GET_POST_DETAILS, DELETE_REPORT } from "../../../api/url";
import { arrowBack, arrowNext, arrowPrev, deleteIcon, ProfileImage } from "../../../assets/image";
import DeletModel from "../../model/DeletModel";
import DissmissReportModel from "../../../components/ReportComponents/DissmissReportModel";
import moment from "moment";
import { strings } from "../../../strings/strings";
import { toast } from "react-toastify";

const PostDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { mutate: deletePost } = useAppMutation();
  const { mutate: dismissReport } = useAppMutation();

  const [results, setResults] = useState({});
  const [currentSlide, setCurrentSlide] = useState(0);
  const [selectedPostId, setSelectedPostId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showDismissModal, setShowDismissModal] = useState(false);
  const [selectedReportId, setSelectedReportId] = useState(null);

  const fromReport = location?.state?.fromReport || false;
  const report = location?.state?.report || null;

  const { data, isLoading, refetch } = useAppQuery({
    queryKey: [QUERY_KEYS.POST_DETAILS, location?.state?.postId],
    url: `${GET_POST_DETAILS}?postId=${location.state?.postId}`,
  });

  useEffect(() => {
    if (data) {
      setResults(data?.results);
    }
  }, [data]);

  const images = Array.isArray(results?.data?.postImages) ? results?.data?.postImages : [];

 const nextSlide = () => {
   setCurrentSlide((prev) => (prev < images.length - 1 ? prev + 1 : prev));
 };

 const prevSlide = () => {
   setCurrentSlide((prev) => (prev > 0 ? prev - 1 : prev));
 };


  const handleDeletePost = (post) => {
    const contentId = post?.id || post?._id || post?.content?.id;
    if (!contentId) {
      toast.error(strings.invalidPostId);
      return;
    }
    setSelectedPostId(contentId);
    setShowModal(true);
  };
  const handleConfirmDelete = () => {
    if (!selectedPostId) {
      toast.error(strings.noPostIdSelected);
      return;
    }
    deletePost(
      {
        url: `${DELETE_CONTENT}?contentId=${selectedPostId}`,
        method: "DELETE",
      },
      {
        onSuccess: () => {
          toast.success(strings.postdeletedSuccess);
          setShowModal(false);
          setSelectedPostId(null);
          setTimeout(() => navigate(-1), 1000);
        },
        onError: () => {
          toast.error(strings.failToDeletePost);
        },
      }
    );
  };

  const handleCancelDelete = () => {
    setShowModal(false);
    setSelectedPostId(null);
  };

  const handleDismissReport = () => {
    if (!report?._id) {
      toast.error(strings.noPostIdSelected);
      return;
    }

    setSelectedReportId(report?._id);
    setShowDismissModal(true);
  };

  const handleConfirmDismiss = () => {
    if (!selectedReportId) {
      toast.error(strings.NoReportSelected);
      return;
    }

    dismissReport(
      {
        url: `${DELETE_REPORT}?reportId=${selectedReportId}`,
        method: "DELETE",
      },
      {
        onSuccess: () => {
          toast.success(strings.reportDissmissSuccess);
          setShowDismissModal(false);
          setSelectedReportId(null);
          refetch();
          setTimeout(() => navigate(-1), 1000);
        },
        onError: () => {
          toast.error(strings.failToDissmissReport);
        },
      }
    );
  };

  const handleCancelDismiss = () => {
    setShowDismissModal(false);
    setSelectedReportId(null);
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="min-h-screen">
      <div className="flex gap-2 mb-5">
        <button onClick={() => navigate(-1)}>
          <img src={arrowBack} alt="Back" />
        </button>
        <div className="text-xl sm:text-2xl font-semibold">Post Details</div>
      </div>

      <div className="max-w-2xl mx-auto rounded-xl overflow-hidden bg-white shadow-lg p-3 sm:p-4">
        <div className="flex items-center justify-between pb-4 border-b">
          <div className="flex items-center">

            {results?.data?.creator?.profileImage ? (
              <img
                src={results.data.creator.profileImage}
                alt="Profile"
                className="w-14 h-14 rounded-full object-cover"
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = ProfileImage; // fallback image on error
                }}
              />
            ) : (
              <div className="w-14 h-14 rounded-full overflow-hidden">
                <img src={ProfileImage} alt="Default Profile" className="w-full h-full object-cover" />
              </div>
            )}

            <div className="ml-4">
              <p className="text-xl font-semibold">{results?.data?.creator?.userName}</p>
              <p className="text-sm text-grey">{results?.data?.formattedDate}</p>
              <p className="text-sm text-light">{moment(results?.data?.createdAt).fromNow()}</p>
            </div>
          </div>

          {fromReport ? (
            <div className="flex gap-3">
              <button onClick={handleDismissReport} className="text-primary font-semibold">
                {strings.dismissReport}
              </button>
              <span className="text-gray-300">|</span>
              <button onClick={() => handleDeletePost(results?.data)} className="text-red-600 font-semibold">
                {strings?.DeletePost}
              </button>
            </div>
          ) : (
            <button onClick={() => handleDeletePost(results?.data)}>
              <img src={deleteIcon} alt="Delete" className="w-6 h-6" />
            </button>
          )}
        </div>

        {images.length > 0 && (
          <div className="relative">
            <p className="text-lg my-3">{results?.data?.caption}</p>
            <div className="overflow-hidden w-full aspect-[4/3] max-h-full mx-auto relative">
              <div
                className="flex transition-transform duration-500 ease-in-out"
                style={{ transform: `translateX(-${currentSlide * 100}%)` }}
              >
                {images.map((src, index) => (
                  <div key={index} className="w-full aspect-[4/3] max-h-ful flex-shrink-0">
                    <img src={src} alt={`Post ${index}`} className="w-full h-full object-fill rounded-lg" />
                  </div>
                ))}
              </div>

              {images.length > 1 && (
                <>
                  {currentSlide > 0 && (
                    <button onClick={prevSlide} className="absolute left-2 top-1/2 transform -translate-y-1/2">
                      <img src={arrowPrev} alt="Previous" className="w-6 h-6" />
                    </button>
                  )}
                  {currentSlide < images.length - 1 && (
                    <button onClick={nextSlide} className="absolute right-2 top-1/2 transform -translate-y-1/2">
                      <img src={arrowNext} alt="Next" className="w-6 h-6" />
                    </button>
                  )}
                </>
              )}
            </div>
          </div>
        )}
      </div>
      {showModal && <DeletModel handleConfirmDelete={handleConfirmDelete} handleCancelDelete={handleCancelDelete} />}
      {showDismissModal && (
        <DissmissReportModel handleconfirmDissmiss={handleConfirmDismiss} handleCancelDissmiss={handleCancelDismiss} />
      )}
    </div>
  );
};

export default PostDetails;
